import {
  Modal,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';

const LoadingScreen = ({ isLoading, children }: { isLoading: boolean, children: React.ReactNode }) => {
  return (
    <Modal isOpen={isLoading} isCentered size="xl" scrollBehavior="inside" variant="ghost" onClose={() => { }}>
      <ModalOverlay />
      <ModalContent alignItems="center" color="white">
        {children}
      </ModalContent>
    </Modal>
  );
};

export default LoadingScreen;
